//
import axios from 'axios'
import { mapActions, mapState } from "vuex"
import { RForm, RTable } from "@/components/reusable_components/next"

//
import RoleModel from "@/models/Role"
import fields from "./fields"
import filters from "./filters"
import headers from "./headers"

//
export default {
    name: "role-list",
    components: {
        RForm, 
        RTable,
    },
    computed: {

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        formProps() {
            return {
                fields,
            }
        },

        /**
         *
         */
        tableProps () {
            return {
                service: RoleModel,
                filters,
                headers,
            }
        },

        //
        ...mapState( "SnackbarModalModule", {
            responseConfirm: "responseConfirm",
        }),
    },
    data () {
        return {
            dialog: false,
            selected: null,
            upload: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
            setItemsTopBar: "setItemsTopBar",
        }),

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( UserModel, error.response.data ) )
        },

        /**
         * 
         */
        delete () {
            this.selected.delete().then( this.successDelete ).then( this.$refs.table.refresh ).catch( this.errorDelete ); 
        },

        /**
         *
         */
        errorDelete ( error ) {
            this.$toast.error( error.message )
        },

        refresh() {
            this.$refs.table.refresh()
        },

        reset() {
            this.dialog = false
        },

        /**
         *
         */
        showFile: (filename, fileExtend) => res => {
            //
            var fileLink = document.createElement('a')
            var fileURL = URL.createObjectURL(res.data)
            //
            fileLink.href = fileURL
            fileLink.download = filename.concat('.').concat(fileExtend)
            //file
            //console.log(fileURL)
            //fileURL.setAttribute('download', filename)

            //window.open(fileURL)
            fileLink.click()
        },

        /**
         *
         */
        submitCreate () {
            this.$router.push({ name: "role-create" })
        },

        /**
         *
         */
        submitDelete ( event ) {
            this.selected = event.item
            this.$toast.confirm( "¿Confirma la eliminación del rol seleccionado?", this.$toaster( this, this.delete ) )
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  model   The model
         */
        submitDownload(model) {
            this.toWait(true)
            var formData = new FormData()
            formData.append("file", this.$refs.form.$el.file.files[0]);
            axios.get(process.env.VUE_APP_API_ROUTE +'/roles/squeleton_excel', {
            responseType: 'blob',
            })
            .then(this.showFile('skeleton', 'xlsx'))
            .catch(this.error)
            .finally(this.toWait)
        },
        
        /**
         *
         */
        submitUpdate ( event ) {
            this.$router.push({ name: "role-update", params: { id: event.item.id } })
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  model   The model
         */
        submitUpload(model) {
            this.toWait(true)
            var formData = new FormData()
            formData.append("file", this.$refs.form.$el.file.files[0]);
            axios.post(process.env.VUE_APP_API_ROUTE +'/roles/excel', formData, {
                headers: {
                    'Content-Encoding': 'gzip',
                    'Content-Type': 'multipart/form-data'
                }
            })            
            .then(this.successUpload)
            .then(this.refresh)
            .then(this.reset)
            .catch(this.error)
            .finally(this.toWait)
        },
        
        /**
         *
         */
        submitUploadDialog () {
            this.dialog = true
        },

        /**
         * 
         */
        successDelete () {
            this.$toast.success( "Rol eliminado exitosamente." )
        },

        /**
         * 
         */
        successUpload () {
            this.$toast.success( "Roles subidos exitosamente." )
        },


        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Roles" )
        this.setItemsTopBar([
            {
                action: this.submitUploadDialog,
                color: "success",
                icon: "cloud_upload",
                text: "subir roles",
                tip: "Subir nuevos roles",
            },
            {
                action: this.submitCreate,
                color: "accent",
                icon: "add_circle",
                text: "crear rol",
                tip: "Crear nuevo rol",
            }
        ])
    },
}